export enum NotificationDomain {
  Purchasing = 'purchasing',
  General = 'general',
  Marketplace = 'marketplace',
  Legacy = 'legacy',
}

export const NOTIFICATION_DOMAINS: readonly NotificationDomain[] = [
  NotificationDomain.Purchasing,
  NotificationDomain.General,
];

export function acceptsNotification(data: unknown): boolean {
  return typeof data === 'object' && data !== null && 'domain' in data
    && NOTIFICATION_DOMAINS.some(domain => domain === data.domain);
}
